<app-header></app-header>
<form class="content container-fluid" [formGroup]="formDenuncia">
    <div class="container">
        <div class="row mb-3 pt-5">
            <div class="mt-2">
                <h2 class="fw-bold mt-md-3;">¿Desea mantener el anonimato?</h2>
                <div class="row">
                    <div class="col-1 form-check">
                        <label class="form-check-label">
                        <input class="form-check-input" type="radio" formControlName="anonimo" (change)="denunciaPrivada(true)" [value]="true">
                        
                            Si
                        </label>
                    </div>
                    <div class="col-1 form-check">
                        <label class="form-check-label">
                        <input class="form-check-input" type="radio" formControlName="anonimo" (change)="denunciaPrivada(false)" [value]="false">
                    
                            No
                        </label>
                    </div>

                </div>

         
           
                <div [ngbCollapse]="anonimo.value" class="row mt-4">
                    <div class="col-6">
                        <label>RUT</label>
                        <input type="text" class="form-control" formControlName="rut" placeholder="xxxxxxxx-x">
                        <div *ngIf="formDenuncia.get('rut')?.invalid || formDenuncia.get('rut')?.errors">
                            <div [ngClass]="{'error-message': formDenuncia.get('rut')?.errors}" *ngIf="formDenuncia.get('rut')?.hasError('required')">Debe ingresar su RUT.</div>
                            <div [ngClass]="{'error-message': formDenuncia.get('rut')?.errors}" *ngIf="formDenuncia.get('rut')?.hasError('rut')">El RUT ingresado es invalido</div>
                        </div>
                    </div>
                    <div class="col-6">
                        <label>Nombre</label>
                        <input type="text" class="form-control" formControlName="nombre">
                        <div *ngIf="formDenuncia.get('nombre')?.invalid">
                            <div [ngClass]="{'error-message': formDenuncia.get('nombre')?.errors}" *ngIf="formDenuncia.get('nombre')?.errors">Debe ingresar un Nombre.</div>
                          </div>
                    </div>
                    <div class="col-6">
                        <label>Apellidos</label>
                        <input type="text" class="form-control" formControlName="apellidos">
                        <div *ngIf="formDenuncia.get('apellidos')?.invalid">
                            <div [ngClass]="{'error-message': formDenuncia.get('apellidos')?.errors}" *ngIf="formDenuncia.get('apellidos')?.errors">Debe ingresar un Apellido.</div>
                          </div>
                    </div>
                    <div class="col-6">
                        <label>E-mail</label>
                        <input type="email" class="form-control" formControlName="email">
                        <div *ngIf="formDenuncia.get('email')?.invalid">
                            <div [ngClass]="{'error-message': formDenuncia.get('email')?.errors}" *ngIf="formDenuncia.get('email')?.errors">El formato del correo electrónico no es válido.</div>
                          </div>
                    </div>
                    <div class="col-6">
                        <label>Teléfono</label>
                        <input type="number" class="form-control" formControlName="fono">
                        <div *ngIf="formDenuncia.get('fono')?.invalid">
                            <div [ngClass]="{'error-message': formDenuncia.get('fono')?.errors}" *ngIf="formDenuncia.get('fono')?.errors">Debe ingresar un Télefono.</div>
                          </div>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-4 mt-3">
                <div class="form-group">
                    <label>Región</label>
                    <select formControlName="regiId" class="form-select form-control">
                    <!--<select formControlName="regiId" (change)="obtenerComunas()" class="form-select form-control">-->
                        <option selected>Selecciona una región</option>
                        <option *ngFor="let region of regiones" [value]="region.regiId">{{region.nombre}}</option>
                    </select>
                    <div *ngIf="formDenuncia.controls['regiId'].invalid">
                        <div [ngClass]="{'error-message': formDenuncia.get('regiId')?.errors}" *ngIf="formDenuncia.get('regiId')?.errors">Debes seleccionar una opción.</div>
                      </div>
                </div>
            </div>
           <!-- <div class="col-12 col-md-4">
                <div class="form-group pb-4">
                    <label>Comuna</label>
                    <select formControlName="comuId" class="form-select form-control">
                        <option selected>Selecciona una comuna</option>
                        <option *ngFor="let comuna of comunas" [value]="comuna.comu_id">{{comuna.comu_nombre}}</option>
                    </select>
                </div>
            </div> -->
            <div class="col-12 col-md-4 mt-3">
                <div class="form-group">
                    <label>*Fecha del Evento </label>
                    <input formControlName="fechaEvento" type="date" class="form-control" [max]="fechaFin" placeholder="Escriba fecha">
                    <div *ngIf="formDenuncia.controls['fechaEvento'].invalid">
                        <div [ngClass]="{'error-message': formDenuncia.get('fechaEvento')?.errors}" *ngIf="formDenuncia.get('fechaEvento')?.errors">Debes ingresar una Fecha.</div>
                      </div>
                </div>
            </div>

            <div class="container pt-4">

                <h2 class="fw-bold mt-4;">*Tipo de Denuncia (especifique al menos 1)</h2>
            </div>
          

            <div class="col-12">
                <div class="accordion">
                    <div *ngFor="let propiedad of propiedades;let idx = index;" class="card">
                        <div class="card-header" >
                            <div class="form-check form-check-inline text-left">
                                <mat-checkbox color="primary" (change)="editarPropiedad(propiedad,$event)" [value]="propiedad.valor" style="
                                position: relative;
                                padding: 0;
                                top: -5px;
                            "></mat-checkbox>
                                <label class="form-check-label ms-2" [innerHTML]="propiedad.nombre">
                                   <!-- {{propiedad.nombre}}-->
                                </label>
                            </div>
                            <div *ngIf="verpropiedad(collapse)" class="float-right">
                                <a class="btn btn-primary" (click)="collapse.toggle()" style="
                                text-align: center;
                                width: 40px;
                                height: 35px;
                            "><img src="../../../assets/img/ver-mas-grid.svg"></a>
                            </div>
                            <div  *ngIf="!verpropiedad(collapse)" class="float-right">
                                <a class="btn btn-primary" (click)="collapse.toggle()" style="
                                text-align: center;
                                width: 40px;
                                height: 35px;
                            "><img src="../../../assets/img/ver-menos-grid.svg"></a>
                            </div>
                            
                        </div>
                        <div #collapse="ngbCollapse" [ngbCollapse]="true" class="collapse">
                            <div class="card-body" style="
                            text-align: justify;">
                               <div [innerHTML]="propiedad.descripcion"></div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header" (click)="collapse.toggle()">
                            <div class="form-check form-check-inline">
                                <mat-checkbox color="primary" (change)="editarPropiedad({proId:0,nombre:'Otro',descripcion:'',valor:0},$event)"  [value]="'0'"></mat-checkbox>
                                <input #otro type="text" class="ms-2" placeholder="Otro" (keyup)="agregarOtro(otro.value)">
                            </div>
                        </div>
                        <div #collapse="ngbCollapse" [ngbCollapse]="true">
                            <div class="card-body">
                                Puede ingresar otro tipo de denuncia si no esta relacionada con alguna de la lista
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3 mb-4">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12 card shadow-sm pt-4 pb-2">
                                <h2 class="fw-bold mt-4;">Los hechos denunciados involucran a:</h2>

                                <div class="col-12 col-md-4 mt-3">
                                    <div class="form-group">
                                        <label>Eliga una opción :</label>
                                        <select formControlName="invoId" class="form-select form-control">
                                        <!--<select formControlName="regiId" (change)="obtenerComunas()" class="form-select form-control">-->
                                            <option selected>Seleccione</option>
                                            <option *ngFor="let invo of involucran" [value]="invo.invoId">{{invo.nombre}}</option>
                                        </select>
                                        <div *ngIf="formDenuncia.controls['invoId'].invalid">
                                            <div [ngClass]="{'error-message': formDenuncia.get('invoId')?.errors}" *ngIf="formDenuncia.get('invoId')?.errors">Debe seleccionar una opción.</div>
                                          </div>
                                    </div>
                                </div>
                                <div class="col-12 mt-3">
                                    <div class="row" *ngIf="formDenuncia.value.invoId == 1">
                                        <div class="col-6 form-check">
                                            <label class="form-check-label">
                                            <input class="form-check-input" type="radio" formControlName="organizacion"  [value]="true">
                                            
                                                Si es un trabajador de la organización ¿A que razón social corresponde?
                                            </label>
                                        </div>
                                        <div class="col-6 form-check">
                                            <label class="form-check-label">
                                            <input class="form-check-input" type="radio" formControlName="organizacion"  [value]="false">
                                        
                                                Si no sabe ¿A qué departamento pertenece?
                                            </label>
                                        </div>
                    
                                    </div>

                                    <div class="row">
                                        <div class="col-6" *ngIf="formDenuncia.value.organizacion && formDenuncia.value.invoId == 1">
                                      
                                            <input type="text" class="form-control" formControlName="trabOrganizacion">
                                            <div *ngIf="formDenuncia.get('trabOrganizacion')?.invalid">
                                                <div [ngClass]="{'error-message': formDenuncia.get('trabOrganizacion')?.errors}" *ngIf="formDenuncia.get('trabOrganizacion')?.errors">Debe ingresar un Texto.</div>
                                              </div>
                                        </div>

                                        <div class="col-6" *ngIf="!formDenuncia.value.organizacion && formDenuncia.value.invoId == 1">
                                     
                                            <input type="text" class="form-control" formControlName="trabDepartamento">
                                            <div *ngIf="formDenuncia.get('trabDepartamento')?.invalid">
                                                <div [ngClass]="{'error-message': formDenuncia.get('trabDepartamento')?.errors}" *ngIf="formDenuncia.get('trabDepartamento')?.errors">Debe ingresar un Texto.</div>
                                              </div>
                                        </div>

                                        <div class="col-6" *ngIf="formDenuncia.value.invoId == 4">
                                         
                                            <input type="text" class="form-control" formControlName="trabOtro">
                                            <div *ngIf="formDenuncia.get('trabOtro')?.invalid">
                                                <div [ngClass]="{'error-message': formDenuncia.get('trabOtro')?.errors}" *ngIf="formDenuncia.get('trabOtro')?.errors">Debe ingresar un Texto.</div>
                                              </div>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                  <div class="row mt-3 mb-4">
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-12 card shadow-sm pt-4 pb-2">
                                                    <div class="row mt-3 hscroll">
                                                        <div class="table-responsive">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr ALIGN=center>
                                                                        <th>Adjunto</th>
                                                                        <th>Fecha de carga</th>
                                                                        <th>Tipo documento</th>
                                                                        <th>Opciones</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody *ngFor="let doc of documentos; let i = index">
                                                                    <tr ALIGN=center>
                                                                        <td>{{doc.nombre}}</td>
                                                                        <td>{{formatoFecha(doc.fecha)}}</td>
                                                                        <td>{{doc.tipo}}</td>
                                                                        <td>
                                                                            <div class="btn-group" role="group"
                                                                                aria-label="Basic example">
                                                                                <div class="dropdown"
                                                                                    data-bs-toggle="tooltip"
                                                                                    data-bs-title="Eliminar Adjunto">
                                                                                    <button type="button" (click)="eliminarDoc(doc, i)"
                                                                                        class="btn btn-light"><img
                                                                                            src="../assets/img/eliminar.svg"></button>
                                                                                </div>
                                                                        
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                
                                                                </tbody>
                                                            </table>

                                                            <div class="row text-end">
                                                                <div class="col-12 mb-2">
                                                                   
                                                                    <button
                                                                        class="btn btn-primary btn-block px-3" (click)="showFile(archivoSol)" ><img
                                                                            src="../assets/img/agregar-antecedentes.svg"
                                                                            style="margin-right: 14px;" >Agregar
                                                                        Antecedentes</button>
                                                                        <input [hidden]="true" type="file"  (change)="cargardocumento($event,'Antecedentes Denunciante')" #archivoSol (click)="archivoSol.value = ''" value="" />
                                                                </div>
                                                     
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                <div class="form-group mt-3 mb-4">
                    <label for="exampleFormControlTextarea1" class="fw-bold">Forma en que tomó conocimientos de los
                        hechos</label>
                    <textarea formControlName="forma" class="form-control" id="exampleFormControlTextarea1" rows="4"></textarea>
                    <div *ngIf="formDenuncia.get('forma')?.invalid">
                        <div [ngClass]="{'error-message': formDenuncia.get('forma')?.errors}" *ngIf="formDenuncia.get('forma')?.errors">Debes ingresar un texto</div>
                      </div>
                    <mat-hint>No entregar datos personales en este texto</mat-hint>
                </div>

                <div class="form-group mb-4">
                    <label for="exampleFormControlTextarea1" class="fw-bold">Descripción detallada de él o los
                        hechos</label>
                    <textarea formControlName="descripcion" class="form-control" id="exampleFormControlTextarea1" rows="4"></textarea>
                    <div *ngIf="formDenuncia.get('descripcion')?.invalid">
                        <div [ngClass]="{'error-message': formDenuncia.get('descripcion')?.errors}" *ngIf="formDenuncia.get('descripcion')?.errors">Debes ingresar un texto</div>
                      </div>
                    <mat-hint>No entregar datos personales en este texto</mat-hint>
                </div>

                <div class="form-group">
                    <label for="exampleFormControlTextarea1" class="fw-bold">Involucrados en los
                        hechos</label>
                    <textarea formControlName="involugrados" class="form-control" id="exampleFormControlTextarea1" rows="4"></textarea>
                    <div *ngIf="formDenuncia.get('involugrados')?.invalid">
                        <div [ngClass]="{'error-message': formDenuncia.get('involugrados')?.errors}" *ngIf="formDenuncia.get('involugrados')?.errors">Debes ingresar un texto</div>
                      </div>
                    <mat-hint>No entregar datos personales en este texto</mat-hint>
                </div>

            </div>
        </div>
      
       
        <div class="row pb-4">
            <div class="col-12 m-2">
                <div class="float-end">
                    <button class="btn btn-primary me-2" (click)="enviarDenuncia()">Enviar su Denuncia</button>
                    <button class="btn btn-primary" (click)="cancelar()">Volver al Home</button>
                </div>
            </div>
        </div>
    </div>
</form>